import { useEffect } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { hasAtLeast } from 'remeda'
import { useCart } from '@velasca/hooks/use-cart'
import type { EmptyCartCta } from '@velasca/types'
import { ErrorFallback } from '@velasca/ui/error-fallback'
import { CartWithItems } from './CartWithItems/CartWithItems'
import { EmptyCart } from './EmptyCart/EmptyCart'

interface CartDataProps {
  complementaryProductSettings?: {
    enabled: boolean
  }
  emptyCartCtas: EmptyCartCta[]
}

export const CartPage = ({ emptyCartCtas }: CartDataProps) => {
  const {
    setError: setCartError,
    loading: cartLoading,
    data: cartData,
  } = useCart()

  useEffect(() => {
    const cartPageSkeleton = document.getElementById('cart-page-skeleton')

    if (
      !cartLoading &&
      cartData?.items &&
      hasAtLeast(cartData.items, 1) &&
      cartPageSkeleton
    ) {
      cartPageSkeleton?.classList.add('react-loaded')
    }
  }, [cartLoading, cartData])

  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={() => {
        setCartError(null)
      }}
    >
      {cartLoading || (cartData?.items && hasAtLeast(cartData.items, 1)) ? (
        <CartWithItems />
      ) : (
        <EmptyCart emptyCartCtas={emptyCartCtas} />
      )}
    </ErrorBoundary>
  )
}
